<template>
  <div v-if="hasAnyAlert" class="flex flex-col gap-2 mb-4">
    <SuspendedOrgAlert v-if="base.suspended" :data="base.suspended" />
    <GoogleAccountsIssuesAlert v-if="base.googleAccountsIssues" :data="base.googleAccountsIssues" />
    <SubscriptionAlert v-if="base.subscription" :data="base.subscription" />
    <LimitReachedAlert v-if="base.limitReached" :data="base.limitReached" />
    <DisconnectedFacebookAlert v-if="base.disconnectedFacebookAccounts" :data="base.disconnectedFacebookAccounts" />
    <CustomAlertItem
      v-for="alert in custom"
      :key="alert.id"
      :alert="alert" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { getOrgAlerts } from '@/api/orgAlerts'
import SuspendedOrgAlert from './SuspendedOrgAlert.vue'
import GoogleAccountsIssuesAlert from './GoogleAccountsIssuesAlert.vue'
import SubscriptionAlert from './SubscriptionAlert.vue'
import LimitReachedAlert from './LimitReachedAlert.vue'
import DisconnectedFacebookAlert from './DisconnectedFacebookAlert.vue'
import CustomAlertItem from './CustomAlertItem.vue'

const base = ref({})
const custom = ref([])

const hasAnyAlert = computed(() => (
  Object.values(base.value).some(Boolean) || custom.value.length > 0
))

onMounted(async() => {
  try {
    const { data } = await getOrgAlerts(window.location.pathname)
    base.value = data.base || {}
    custom.value = data.custom || []
  } catch {
    // Silent fail — alerts are non-critical. Real errors will show up in network panel.
  }
})
</script>
